<template>
	<div class="cart-over">
		<font-awesome-icon icon="shopping-cart" size="2x" style="padding: 5px;"/>
		<div class="counter"> {{ counter }} </div>
		<div class="cart-content">
			<div class="cart-header">
				<div class="row">
					<div class="col-md-5 p-3">
						<p class="header-content"><b> {{ counter }} </b> itens</p>
					</div>
					<div class="col-md-2 p-3">
						<p class="header-content">Subtotal: &nbsp;</p>
					</div>
					<div class="col-md-5 p-3 ">
						<p class="header-price text-right"><span class="price">{{ subtotal }}</span></p>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<router-link to="/carrinho" class="btn btn-primary btn-block">Ir para carrinho</router-link>
					</div>
				</div>
				<div class="row">
					<div class="col-12" v-for="(i, k) in itemsCart" v-if="k < 3" style="border-bottom: 1px solid #CCC;">
						<div class="row">
							<div class="col-3 align-middle p-3">
								<img style="width: 90%;" src="~@/assets/imgs/icones/cartoriosparticipante.png" />
							</div>
							<div class="col-5 align-middle p-3">
								{{ i.descricao }}
							</div>
							<div class="col-3 align-middle p-3">
								{{ currencyFormatter.format(i.valor) }}
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 text-center">
						<br>
						<b-link to="carrinho">Ver mais</b-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'})
			}
		},
		computed: {
			counter() {
				return this.$store.state.cart.item.length;
			},
			itemsCart() {
				return this.$store.state.cart.item;
			},
			subtotal() {
				return this.currencyFormatter.format(this.$store.state.cart.subtotal)
			}
		},
		methods: {
			formatPrice(value) {

			}
		},
		created() {
			let cart = this.$cookies.get('b_cart');
			cart = atob(cart);
			this.$store.commit('cart/set', JSON.parse(cart));
		},
	};
</script>

<style>
	.counter {
		background-color: #999;
		position: absolute;
		padding: 3px;
		margin-top: -45px;
		margin-left: 30px;
		border-radius: 100%;
		color: #FFF;
		font-size: 10px;
		min-width: 15px;
		text-align: center;
	}
	.cart-content {
		width: 350px;
		min-height: 250px;
		background-color: #FFF;
		border: 1px solid #CCC;
		position: absolute;
		right: 5px;
		top: 75px;
		border-radius: 7px;
		z-index: 9999;
		cursor: default ;
		display: none;
	}

	.cart-over:hover  .cart-content {
		display: block;
	}

	p.header-content {
		margin-top: 10px;
		color: #4780F1;
		font-size: 14px;
	}

	p.header-price {
		margin-top: 7px;
		font-weight: bold;
		color: #4780F1;
	}

	.cart-content .row {
		margin: 0px !important;
	}

	.cart-content .cart-header span.price {
		font-size: 20px;
	}
</style>